import { Directive, ElementRef, EventEmitter, Input, Output } from '@angular/core';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { ApplicationRecord } from '@models/apollo';
import { User } from '@queries/generated';

import { FieldsRequiredNotificationMeta } from './fields-required-notification/fields-required-notification.component';

export interface PersistentNotification extends Partial<ApplicationRecord> {
  value?: string;
  name?: string;
  inviter?: Pick<User, 'fullName'>;
  meta?: FieldsRequiredNotificationMeta; // Union additional types as needed
}

@Directive()
export abstract class BasePersistentNotification {
  @Input() record: PersistentNotification;
  @Input() icon: IconProp;
  @Input() header: string;
  @Input() subheader: string;
  @Input() message: string;
  @Input() dismissible = false;

  @Output() dismiss = new EventEmitter();

  constructor(private el: ElementRef) {}

  onDismiss(event?: Event) {
    event?.stopPropagation();
    this.dismiss.emit();

    this.el.nativeElement.remove();
  }
}
